import React from "react";

const BookmarksContext = React.createContext({
  bookmarks: [],
  addBookmark: () => {},
  deleteBookmark: () => {}
});

export default BookmarksContext;
